(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6734],{

/***/ 86734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content062": function() { return /* binding */ Content062; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var _Content074_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84480);
/* harmony import */ var _Content074_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Content074_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Content062 = function(param) {
    var payload = param.payload;
    var ref;
    var attachments = (ref = payload === null || payload === void 0 ? void 0 : payload.attachments) !== null && ref !== void 0 ? ref : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content074_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Content074_module_scss__WEBPACK_IMPORTED_MODULE_2___default().files),
                children: attachments.map(function(attachment) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content074_module_scss__WEBPACK_IMPORTED_MODULE_2___default().file),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading6 */ .Cd, {
                                className: (_Content074_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                                children: attachment.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .DownloadFile */ .xn, {
                                file: attachment.file,
                                label: attachment.attachmentButtonText
                            })
                        ]
                    }, attachment.id);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content062);


/***/ }),

/***/ 84480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content074_wrapper__Q88Go","files":"Content074_files__FcESP","file":"Content074_file__0GYfl","title":"Content074_title__syuCu"};

/***/ })

}]);